import styled, { css } from 'styled-components';
import { Link } from 'react-router';
import { Image } from '@user-portal/wikr-components';

import Logo from 'assets/images/logo.svg';
import LogoLabel from 'assets/images/logo-label.svg';

const baseLogo = css`
    display: block;
    height: 100%;
    width: auto;
`;

export const LogoContainer = styled(Link)<{ height: number | undefined }>`
    display: flex;
    align-items: center;
    gap: 8px;
    height: ${({ height }) => (height ? `${height}px` : 'auto')};
`;

export const LogoImageSvg = styled(Logo)<{ $maxWidth?: number }>`
    ${baseLogo};
    ${({ $maxWidth }) => Number.isInteger($maxWidth) && `max-width: ${$maxWidth}px;`};
`;

export const LogoImage = styled(Image)`
    ${baseLogo};
`;

export const LogoText = styled(LogoLabel)<{ $maxWidth: number }>`
    ${baseLogo};
    max-width: ${({ $maxWidth }) => $maxWidth}px;
    position: relative;
    top: 1px;
`;
